import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useJITDisabled } from 'api/configurations';
import ConfigurationStatusCard from 'components/home/ConfigurationsStatus/ConfigurationStatusCards/ConfigurationStatusCard';
import DisabledModeTooltip from 'components/shared/DisabeldModeToolTip';
import { useIdPConfigContext } from 'contexts/IdPConfigContext';
import React, { useCallback } from 'react';
import { useNavigateToJit } from 'utils/navigation';
import JITStatusFooter from './JITStatusFooter';

const JITConfigurationStatusCard: React.FC = () => {
	const { isSubTenant } = useIdPConfigContext();
	const { navigateToJit } = useNavigateToJit();
	const { isLoading } = useJITDisabled();

	const handleClick = useCallback(() => {
		if (isLoading || isSubTenant) {
			return;
		}

		navigateToJit();
	}, [isLoading, navigateToJit, isSubTenant]);

	return (
		<DisabledModeTooltip
			title={intl.tr('general.guide.disabledTooltip')}
			placement="right"
			disabled={isSubTenant}
		>
			<ConfigurationStatusCard
				onClick={handleClick}
				disabled={isLoading || isSubTenant}
				icon={<PersonAddIcon fontSize="large" />}
				title={intl.tr('scimConfig.guide.jit.pageTitle')}
				testIdTopic="jit"
				footerContent={<JITStatusFooter />}
			/>
		</DisabledModeTooltip>
	);
};

export default JITConfigurationStatusCard;
